import React from 'react';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import styled from 'styled-components';
import { Paragraph } from '../components/Paragraph/Paragraph';
import { CopyRight } from '../components/Text';

interface IContactContentProps {
    headerVisible?: boolean;
}

export const Contact = ({ headerVisible = true }: IContactContentProps) => {
    const theme = useTheme();
    const deviceTabletAndPhone = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Container container>
            {headerVisible ? (
                <Header item xs={12} md={12} textAlign="center">
                    <Paragraph size="l" bold margin="s">
                        Masz wątpliwość, czy Twoja sprawa mieści się w moim katalogu?
                    </Paragraph>
                    <Paragraph size="m">Skontaktuj się ze mną!</Paragraph>
                </Header>
            ) : null}
            <Grid item md={12}>
                <Grid container alignItems="center" justifyContent="center">
                    <MapContainer>
                        <img width={'100%'} src="/resources/images/mapa.jpg" />
                    </MapContainer>
                    <ContactContainer>
                        <ContactWrapper container direction={deviceTabletAndPhone ? 'row' : 'column'}>
                            <ContactTexts>
                                <ContactText bold>Kontakt:</ContactText>
                                <ContactText image={'/resources/icons/icon-12.svg'}>
                                    <a href="tel:+48661533865">661 533 865</a>
                                </ContactText>
                                <ContactText image={'/resources/icons/icon-13.svg'}>
                                    <a href="mailto:kontakt@kancelariaolczyk.pl">kontakt@kancelariaolczyk.pl</a>
                                </ContactText>
                            </ContactTexts>
                            <ContactTexts className="landing-page-contact__address">
                                <ContactText bold image={'/resources/icons/icon-14.svg'}>
                                    Adres:
                                </ContactText>
                                <ContactText>Kancelaria Radcy Prawnego</ContactText>
                                <ContactText>Michał Olczyk</ContactText>
                                <ContactText>ul. Brzezińska 14</ContactText>
                                <ContactText>95-040 Koluszki</ContactText>
                            </ContactTexts>
                        </ContactWrapper>
                    </ContactContainer>
                </Grid>
            </Grid>
        </Container>
    );
};

function ContactText(props: any) {
    return (
        <Grid container alignItems="center">
            <ContactTextImg src={props.image ? props.image : ' '} />
            <CopyRight bold={props.bold}>{props.children}</CopyRight>
        </Grid>
    );
}

const Container = styled(Grid)`
    padding-top: 20px;

    ${(props) => props.theme.breakpoints.between('md', 'lg')} {
        padding-top: 3vh;
    }

    ${(props) => props.theme.breakpoints.down('md')} {
        padding: 50px 0;
    }
`;

const ContactTexts = styled.div`
    padding-left: 20px;
    padding-top: 10px;

    ${(props) => props.theme.breakpoints.down('md')} {
        &:first-child {
            padding-right: 50px;
        }

        &:last-child {
            margin-top: -5px;
        }
    }

    ${(props) => props.theme.breakpoints.down('sm')} {
        display: block;
        width: 100%;
        padding: 20px 20px;
    }
`;

const ContactTextImg = styled.img`
    width: 25px;
    margin-right: 5px;
`;

const Header = styled(Grid)`
    padding-bottom: 50px;
`;

const MapContainer = styled.div`
    max-width: 350px;

    ${(props) => props.theme.breakpoints.down('md')} {
        // padding: 0 100px;
        padding-top: 40px;
        order: 2;
        max-width: 600px;
    }
`;

const ContactContainer = styled.div`
    // flex: 1;

    ${(props) => props.theme.breakpoints.down('md')} {
        // padding: 0 100px;
        order: 1;
    }
`;

const ContactWrapper = styled(Grid)`
    ${(props) => props.theme.breakpoints.down('md')} {
        justify-content: center;
        // align-items: center;
    }
`;
